import './CustomerHistory.scss';
import Component from './CustomerHistory.js';
export default Component;
